import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  label: {
    display: 'block',
    fontFamily: 'Source Sans Pro Semibold',
    margin: `${theme.spacing(3)} 0 ${theme.spacing(2.4)} 0`,
  },

  minorSpacer: { marginTop: theme.spacing(2) },
  switchRoot: { display: 'block' },

  switchLabel: {
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
  },

  total: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '16px',
    fontWeight: 500,
    alignItems: 'center',
    display: 'flex',
    marginTop: '18px',
    marginLeft: '12px',
  },

  tax: {
    fontSize: '12px',
    color: theme.palette.grey[600],
    whiteSpace: 'break-spaces',
  },

  smallText: { fontSize: '14px' },

  footerValue: {
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    whiteSpace: 'break-spaces',
  },

  hint: { color: theme.palette.grey[600] },
  info: { marginLeft: theme.spacing(0.5) },

  subHeader: {
    backgroundColor: theme.palette.common.white,
    position: 'sticky',
    fontWeight: 'bold',
  },

  menuItem: { marginLeft: theme.spacing(1) },
  frequency: { paddingLeft: theme.spacing(1) },
})
